import { useQuery } from '@tanstack/react-query';

import { getRecordings } from '../../api/services/Recordings';
import { DEFAULT_ROWS_PER_PAGE } from '../../constants/queryParams';

export interface RecordingsQueryParams {
  page: number;
  perPage: number;
  riderName?: string;
  startDate?: string;
  endDate?: string;
}

// Export when needed for cache invalidation (e.g. after a download request).
const RECORDINGS_QUERY_KEY = 'device_recordings';

export const DEFAULT_RECORDINGS_PARAMS: RecordingsQueryParams = {
  page: 1,
  perPage: DEFAULT_ROWS_PER_PAGE,
};

export const useRecordingsQuery = (queryParams: RecordingsQueryParams) => {
  const { data, isFetching, isSuccess } = useQuery({
    queryKey: [RECORDINGS_QUERY_KEY, queryParams],
    queryFn: async ({ signal }) => {
      const response = await getRecordings(queryParams, signal);

      if (response.type === 'error') {
        throw new Error(response.error.errors[0] ?? 'Failed to load recordings');
      }

      return response.data;
    },
  });

  return {
    recordings: data?.deviceRecordings ?? [],
    isLoading: isFetching,
    isSuccess,
    totalCount: data?.deviceRecordings.length ?? 0,
  };
};
